import React, { Fragment, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loader from "./Layout/Loader/Loader";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthProvider";
import RequireAuth from "./Hooks/RequireAuth";
import ForgetPassword from "./screens/Membership/ForgetPassword";

const App = lazy(() => import("./components/app2"));
const Dashboard = lazy(() => import("./screens/Dashboard/Dashboard"));
const SelfPayingMembershipForm = lazy(
  () => import("./screens/Membership/SelfPayingMembershipForm")
);
const CorparateMembershipSignUp = lazy(
  () => import("./screens/Membership/CorparateMembershipSignUp")
);
const MembershipForm = lazy(
  () => import("./screens/Membership/MembershipForm")
);
const CorparateDashboard = lazy(
  () => import("./screens/Corporate/CorporateDashboard")
);
const CorparateMembershipForm = lazy(
  () => import("./screens/Membership/CorparateMembershipForm")
);
const TanStackQueryProvider = lazy(() => import("./service/tanStackProvider"));
const SecurePackages = lazy(() => import("./screens/packages/securepackages"));
const HealthGuardPackage = lazy(
  () => import("./screens/packages/HealthguardPackages")
);
const AdminDashboard = lazy(() => import("./screens/admin/dashboard"));
const CorporateDetails = lazy(() => import("./screens/admin/corporateDetails"));
const CorporateRegistrations = lazy(
  () => import("./screens/admin/CorporateRegistration")
);
const CorparateMembershipSignIn = lazy(
  () => import("./screens/Membership/CorparateMembershipSignIn")
);
const IndividualRegistration = lazy(
  () => import("./screens/admin/IndividualRegistration")
);

const UnderwriitingMembers = lazy(
  () => import("./screens/admin/UnderwriitingMembers")
);

const UnderwriitingReport = lazy(
  () => import("./screens/admin/UnderwriitingReport")
);

const IndividualReview = lazy(() => import("./screens/admin/IndividualReview"));

const Login = lazy(
  () => import("./screens/Membership/CorparateMembershipLogIn")
);

const CorporateSendForms = lazy(
  () => import("./screens/admin/CorporateSendForms")
);

const ChangePassword = lazy(() => import("./screens/Corporate/ChangePassword"));

const container: HTMLElement | any = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Fragment>
      <BrowserRouter>
        <TanStackQueryProvider>
          <AuthProvider>
            <React.Suspense fallback={<Loader />}>
              <Routes>
                <Route path={`${process.env.PUBLIC_URL}/`} element={<App />}>
                  <Route
                    path={`${process.env.PUBLIC_URL}/`}
                    element={<Dashboard />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/secure/package`}
                    element={<SecurePackages />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/healthguard/package`}
                    element={<HealthGuardPackage />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/individual/membership`}
                    element={<SelfPayingMembershipForm />}
                  />

                  <Route
                    path={`${process.env.PUBLIC_URL}/membership/form`}
                    element={<MembershipForm />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/corporate/membership`}
                    element={<CorparateMembershipSignUp />}
                  />

                  <Route
                    path={`${process.env.PUBLIC_URL}/forget/password`}
                    element={<ForgetPassword />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/corporate/membership/signup`}
                    element={<CorparateMembershipSignIn />}
                  />
                  <Route
                    path={`${process.env.PUBLIC_URL}/corporate/registration/:id?/:id2?`}
                    element={<CorparateMembershipForm />}
                  />

                  <Route
                    path={`${process.env.PUBLIC_URL}/corporate/login`}
                    element={<Login />}
                  />

                  <Route element={<RequireAuth allowedRoles={["USER"]} />}>
                    <Route
                      path={`${process.env.PUBLIC_URL}/corporate/dashboard`}
                      element={<CorparateDashboard />}
                    />
                    <Route
                      path={`${process.env.PUBLIC_URL}/corporate/change/password`}
                      element={<ChangePassword />}
                    />
                  </Route>

                  <Route
                    element={<RequireAuth allowedRoles={["SUPER_ADMIN"]} />}
                  >
                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/dashboard`}
                      element={<AdminDashboard />}
                    />
                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/individual/applicants`}
                      element={<IndividualRegistration />}
                    />
                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/corporate/registration/detsils`}
                      element={<CorporateDetails />}
                    />
                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/corporate/registration/info/:id?`}
                      element={<CorporateRegistrations />}
                    />
                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/corporate/:name?/application/forms/send/:id?`}
                      element={<CorporateSendForms />}
                    />
                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/underwriting/members`}
                      element={<UnderwriitingMembers />}
                    />

                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/underwriting/report`}
                      element={<UnderwriitingReport />}
                    />

                    <Route
                      path={`${process.env.PUBLIC_URL}/admin/Individual/applicants/review`}
                      element={<IndividualReview />}
                    />
                  </Route>
                </Route>
              </Routes>
            </React.Suspense>
          </AuthProvider>
        </TanStackQueryProvider>
      </BrowserRouter>
    </Fragment>
  </React.StrictMode>
);

reportWebVitals();
